export const CHANGE_TO_OB_MODAL_ID = 'change-to-ob-modal';
